import Tooltip from './tooltip'

Tooltip.install = vue => {
  vue.component(Tooltip.name, Tooltip)
}

export default Tooltip
